import { render, staticRenderFns } from "./perfis.vue?vue&type=template&id=18a29fdc"
import script from "./perfis.vue?vue&type=script&lang=js"
export * from "./perfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports